import React from "react";

import areaIcon from "./images/node/AREA/default.gif";
import cropIcon from "./images/node/CROP/default.gif";
import deviceIcon from "./images/node/DEVICE/default.gif";
// import eventIcon from "./images/node/EVENT/default.gif";
import extensionIcon from "./images/node/EXTENSION/default.gif";
import panelIcon from "./images/node/PANEL/default.gif";
import tagIcon from "./images/node/TAG/default.gif";

import appleCropIcon from "./images/node/CROP/APPLE.gif";
import apricotCropIcon from "./images/node/CROP/APRICOT.gif";
import bananaCropIcon from "./images/node/CROP/BANANA.gif";
import barleyCropIcon from "./images/node/CROP/BARLEY.gif";
// import beanCropIcon from "./images/node/CROP/BEAN.gif";
import beetCropIcon from "./images/node/CROP/BEET.gif";
import cacaoCropIcon from "./images/node/CROP/CACAO.gif";
import carrotCropIcon from "./images/node/CROP/CARROT.gif";
import celeryCropIcon from "./images/node/CROP/CELERY.gif";
import cherryCropIcon from "./images/node/CROP/CHERRY.gif";
import chillipepperCropIcon from "./images/node/CROP/CHILLIPEPPER.gif";
import coffeeCropIcon from "./images/node/CROP/COFFEE.gif";
import colzaCropIcon from "./images/node/CROP/COLZA.gif";
import cottonCropIcon from "./images/node/CROP/COTTON.gif";
import cucumberCropIcon from "./images/node/CROP/CUCUMBER.gif";
import grapeCropIcon from "./images/node/CROP/GRAPE.gif";
import grassturfCropIcon from "./images/node/CROP/GRASSTURF.gif";
import hopCropIcon from "./images/node/CROP/HOP.gif";
import lettuceCropIcon from "./images/node/CROP/LETTUCE.gif";
import maizeCropIcon from "./images/node/CROP/MAIZE.gif";
import melonCropIcon from "./images/node/CROP/MELON.gif";
import milletCropIcon from "./images/node/CROP/MILLET.gif";
import oliveCropIcon from "./images/node/CROP/OLIVE.gif";
import onionCropIcon from "./images/node/CROP/ONION.gif";
import peaCropIcon from "./images/node/CROP/PEA.gif";
import peachCropIcon from "./images/node/CROP/PEACH.gif";
import pearCropIcon from "./images/node/CROP/PEAR.gif";
import pistachioCropIcon from "./images/node/CROP/PISTACHIO.gif";
import plumCropIcon from "./images/node/CROP/PLUM.gif";
import potatoCropIcon from "./images/node/CROP/POTATO.gif";
import riceCropIcon from "./images/node/CROP/RICE.gif";
import sorghumCropIcon from "./images/node/CROP/SORGHUM.gif";
import soybeanCropIcon from "./images/node/CROP/SOYBEAN.gif";
import strawberryCropIcon from "./images/node/CROP/STRAWBERRY.gif";
import sugarcaneCropIcon from "./images/node/CROP/SUGARCANE.gif";
import sunflowerCropIcon from "./images/node/CROP/SUNFLOWER.gif";
import tomatoCropIcon from "./images/node/CROP/TOMATO.gif";
import walnutCropIcon from "./images/node/CROP/WALNUT.gif";
import wheatCropIcon from "./images/node/CROP/WHEAT.gif";

// import addTimerExtensionIcon from "./images/node/EXTENSION/ADDTIMER.gif";
// import calculationExtensionIcon from "./images/node/EXTENSION/CALCULATION.gif";
// import diseaseExtensionIcon from "./images/node/EXTENSION/DISEASE.gif";
// import exportExtensionIcon from "./images/node/EXTENSION/EXPORTEXTENSION.gif";
// import meteoExtensionIcon from "./images/node/EXTENSION/METEOEXTENSION.gif";
// import plbExtensionIcon from "./images/node/EXTENSION/PLBEXTENSION.gif";
// import waterExtensionIcon from "./images/node/EXTENSION/WATEREXTENSION.gif";

import compoundPanelIcon from "./images/node/PANEL/COMPOUND.gif";
import eventsPanelIcon from "./images/node/PANEL/EVENTS.gif";
import explorerPanelIcon from "./images/node/PANEL/EXPLORER.gif";
import logviewerPanelIcon from "./images/node/PANEL/LOGVIEWER.gif";
import mapPanelIcon from "./images/node/PANEL/MAP.gif";
import nodelistPanelIcon from "./images/node/PANEL/NODELIST.gif";
import trendPanelIcon from "./images/node/PANEL/TREND.gif";

import accgrTagIcon from "./images/node/TAG/ACCGR.gif";
import airpressTagIcon from "./images/node/TAG/AIRPRESS.gif";
import altitudeTagIcon from "./images/node/TAG/ALTITUDE.gif";
import barometricPressureTagIcon from "./images/node/TAG/BAROMETRIC_PRESSURE.gif";
import battTagIcon from "./images/node/TAG/BATT.gif";
import concentationTagIcon from "./images/node/TAG/CONCENTRATION.gif";
import concentationMolTagIcon from "./images/node/TAG/CONCENTRATION_MOL.gif";
import concentationNaClTagIcon from "./images/node/TAG/CONCENTRATION_NACL.gif";
import concentationRatioTagIcon from "./images/node/TAG/CONCENTRATION_RATIO.gif";
import cpTagIcon from "./images/node/TAG/CP.gif";
import cpuloadTagIcon from "./images/node/TAG/CPULOAD.gif";
import dataDelayTagIcon from "./images/node/TAG/DATADELAY.gif";
import dewpointTagIcon from "./images/node/TAG/DEWPOINT.gif";
import digitalTagIcon from "./images/node/TAG/DIGITAL.gif";
import discSizeTagIcon from "./images/node/TAG/DISKSIZE.gif";
import flowTagIcon from "./images/node/TAG/FLOW.gif";
import frequencyTagIcon from "./images/node/TAG/FREQUENCY.gif";
import globalRadiationTagIcon from "./images/node/TAG/GR.gif";
import gsmsqTagIcon from "./images/node/TAG/GSMSQ.gif";
import hailTagIcon from "./images/node/TAG/HAIL.gif";
import hailHitsTagIcon from "./images/node/TAG/HAILHITS.gif";
import hailIntensityTagIcon from "./images/node/TAG/HAILINTENSITY.gif";
import indexTagIcon from "./images/node/TAG/INDEX.gif";
import internalTemperatureTagIcon from "./images/node/TAG/INTTEMP.gif";
import irgvolTagIcon from "./images/node/TAG/IRGVOL.gif";
import latitudeTagIcon from "./images/node/TAG/LATITUDE.gif";
import lengthTagIcon from "./images/node/TAG/LENGTH.gif";
import longitudeTagIcon from "./images/node/TAG/LONGITUDE.gif";
import leafWetnessTagIcon from "./images/node/TAG/LW.gif";
import magnetDirTagIcon from "./images/node/TAG/MAGNETDIR.gif";
import massTagIcon from "./images/node/TAG/MASS.gif";
import memsizeTagIcon from "./images/node/TAG/MEMSIZE.gif";
import nettrafficTagIcon from "./images/node/TAG/NETTRAFFIC.gif";
import pressureTagIcon from "./images/node/TAG/PRESSURE.gif";
import radioErrorTagIcon from "./images/node/TAG/RADIOERROR.gif";
import rainTagIcon from "./images/node/TAG/RAIN.gif";
import rainEventTagIcon from "./images/node/TAG/RAINEVENT.gif";
import rainIntensityTagIcon from "./images/node/TAG/RAININTENSITY.gif";
import rfTagIcon from "./images/node/TAG/RF.gif";
import rfInTagIcon from "./images/node/TAG/RFIN.gif";
import rfOutTagIcon from "./images/node/TAG/RFOUT.gif";
import relativeHumidityTagIcon from "./images/node/TAG/RH.gif";
import rssiTagIcon from "./images/node/TAG/RSSI.gif";
import smCalibratedTagIcon from "./images/node/TAG/SM_CALIBRATED.gif";
import smGypSumTagIcon from "./images/node/TAG/SM_GYPSUM.gif";
import smPercentageTagIcon from "./images/node/TAG/SM_PERCENTAGE.gif";
import smSfuTagIcon from "./images/node/TAG/SM_SFU.gif";
import smTensioTagIcon from "./images/node/TAG/SM_TENSIO.gif";
import smWfvTagIcon from "./images/node/TAG/SM_WFV.gif";
import soilTemperatureTagIcon from "./images/node/TAG/SOILTEMP.gif";
import solarCellTagIcon from "./images/node/TAG/SOLARCELL.gif";
import temperatureTagIcon from "./images/node/TAG/TEMP.gif";
import timeTagIcon from "./images/node/TAG/TIME.gif";
import volumeTagIcon from "./images/node/TAG/VOLUME.gif";
import wetbulbTagIcon from "./images/node/TAG/WETBULB.gif";
import windDirectionTagIcon from "./images/node/TAG/WINDDIR.gif";
import windSpeedTagIcon from "./images/node/TAG/WINDSPEED.gif";
import windSpeedPeakTagIcon from "./images/node/TAG/WINDSPEEDPEAK.gif";
import wlLengthTagIcon from "./images/node/TAG/WL_LENGTH.gif";
import wlPressureTagIcon from "./images/node/TAG/WL_PRESSURE.gif";

import errorIcon from "./images/tree/error.gif";
import warnIcon from "./images/tree/warn.gif";
import disabledExtensionIcon from "./images/tree/disabled_ext.gif";
import enabledExtensionIcon from "./images/tree/enabled_ext.gif";
import executingExtensionIcon from "./images/tree/executing_ext.gif";
// import forecastIcon from "./images/tree/forecast.png";

// TODO instead of is... has... could be better!
// TODO NodeIcon is misleading, find a better name
// TODO See com.adcon.addweb.app.filters.ImageFilter (e.g., for extension icon handling)

interface Props {
  // id: string;
  // displayName: string;
  __typename: string;
  nodeClassName?: string;
  subClass: string;
  error?: boolean;
  warn?: boolean;
  // hasForecast?: boolean;
  executing?: boolean;
  enabled?: boolean;
  iconPosition?: IconPosition; // TODO enum!
}

function typenameToNodeClassName(name: string) {
  // TODO use NodeClasses
  switch (name) {
    case "AreaNode":
      return "AREA";
    case "CropNode":
      return "CROP";
    case "DeviceNode":
      return "DEVICE";
    // case "EventNode":
    //   return eventIcon;
    case "ExtensionNode":
      return "EXTENSION";
    case "PanelNode":
      return "PANEL";
    case "TagNode":
    case "AnalogTagNode":
    case "DigitalTagNode":
      return "TAG";
    default:
      return undefined;
  }
}

function nodeClassToIcon(name: string, subClass: string) {
  switch (name) {
    case "AREA":
      return areaIcon;
    case "CROP":
      return cropSubClassToIcon(subClass);
    case "DEVICE":
      return deviceIcon;
    // case "EVENT":
    //   return eventIcon;
    case "EXTENSION":
      return extensionIcon;
    // return extensionSubClassToIcon(subClass);
    case "PANEL":
      return panelSubClassToIcon(subClass);
    case "TAG":
      return tagSubClassToIcon(subClass);
    default:
      return undefined;
  }
}

function cropSubClassToIcon(name: string) {
  switch (name) {
    case "apple":
      return appleCropIcon;
    case "apricot":
      return apricotCropIcon;
    case "banana":
      return bananaCropIcon;
    case "barley":
      return barleyCropIcon;
    // case "bean":
    //   return beanCropIcon;
    case "beet":
      return beetCropIcon;
    case "cacao":
      return cacaoCropIcon;
    case "carrot":
      return carrotCropIcon;
    case "celery":
      return celeryCropIcon;
    case "cherry":
      return cherryCropIcon;
    case "chillipepper":
      return chillipepperCropIcon;
    case "coffee":
      return coffeeCropIcon;
    case "colza":
      return colzaCropIcon;
    case "cotton":
      return cottonCropIcon;
    case "cucumber":
      return cucumberCropIcon;
    case "grape":
      return grapeCropIcon;
    case "grassturf":
      return grassturfCropIcon;
    case "hop":
      return hopCropIcon;
    case "lettuce":
      return lettuceCropIcon;
    case "maize":
      return maizeCropIcon;
    case "melon":
      return melonCropIcon;
    case "millet":
      return milletCropIcon;
    case "olive":
      return oliveCropIcon;
    case "onion":
      return onionCropIcon;
    case "pea":
      return peaCropIcon;
    case "peach":
      return peachCropIcon;
    case "pear":
      return pearCropIcon;
    case "pistachio":
      return pistachioCropIcon;
    case "plum":
      return plumCropIcon;
    case "potato":
      return potatoCropIcon;
    case "rice":
      return riceCropIcon;
    case "sorghum":
      return sorghumCropIcon;
    case "soybean":
      return soybeanCropIcon;
    case "strawberry":
      return strawberryCropIcon;
    case "sugarcane":
      return sugarcaneCropIcon;
    case "sunflower":
      return sunflowerCropIcon;
    case "tomato":
      return tomatoCropIcon;
    case "walnut":
      return walnutCropIcon;
    case "wheat":
      return wheatCropIcon;

    default:
      return cropIcon;
  }
}

// function extensionSubClassToIcon(name: string) {
//   switch (name) {
//     case "ADDTIMER":
//       return addTimerExtensionIcon;
//     case "CALCULATION":
//       return calculationExtensionIcon;
//     case "DISEASE":
//       return diseaseExtensionIcon;
//     case "EXPORTEXTENSION":
//       return exportExtensionIcon;
//     case "METEOEXTENSION":
//       return meteoExtensionIcon;
//     case "PLBEXTENSION":
//       return plbExtensionIcon;
//     case "WATEREXTENSION":
//       return waterExtensionIcon;
//     default:
//       return extensionIcon;
//   }
// }

function panelSubClassToIcon(name: string) {
  switch (name) {
    case "COMPOUND":
      return compoundPanelIcon;
    case "EVENTS":
      return eventsPanelIcon;
    case "EXPLORER":
      return explorerPanelIcon;
    case "LOGVIEWER":
      return logviewerPanelIcon;
    case "MAP":
      return mapPanelIcon;
    case "NODELIST":
      return nodelistPanelIcon;
    case "TREND":
      return trendPanelIcon;
    default:
      return panelIcon;
  }
}

function tagSubClassToIcon(name: string) {
  switch (name) {
    case "ACCGR":
      return accgrTagIcon;
    case "AIRPRESS":
      return airpressTagIcon;
    case "ALTITUDE":
      return altitudeTagIcon;
    case "BAROMETRIC_PRESSURE":
      return barometricPressureTagIcon;
    case "BATT":
      return battTagIcon;
    case "CONCENTRATION":
      return concentationTagIcon;
    case "CONCENTRATION_MOL":
      return concentationMolTagIcon;
    case "CONCENTRATION_NACL":
      return concentationNaClTagIcon;
    case "CONCENTRATION_RATIO":
      return concentationRatioTagIcon;
    case "CP":
      return cpTagIcon;
    case "CPULOAD":
      return cpuloadTagIcon;
    case "DATADELAY":
      return dataDelayTagIcon;
    case "DEWPOINT":
      return dewpointTagIcon;
    case "DIGITAL":
      return digitalTagIcon;
    case "DISKSIZE":
      return discSizeTagIcon;
    case "FLOW":
      return flowTagIcon;
    case "FREQUENCY":
      return frequencyTagIcon;
    case "GR":
      return globalRadiationTagIcon;
    case "GSMSQ":
      return gsmsqTagIcon;
    case "HAIL":
      return hailTagIcon;
    case "HAILHITS":
      return hailHitsTagIcon;
    case "HAILINTENSITY":
      return hailIntensityTagIcon;
    case "INDEX":
      return indexTagIcon;
    case "INTTEMP":
      return internalTemperatureTagIcon;
    case "IRGVOL":
      return irgvolTagIcon;
    case "LATITUDE":
      return latitudeTagIcon;
    case "LENGTH":
      return lengthTagIcon;
    case "LONGITUDE":
      return longitudeTagIcon;
    case "LW":
      return leafWetnessTagIcon;
    case "MAGNETDIR":
      return magnetDirTagIcon;
    case "MASS":
      return massTagIcon;
    case "MEMSIZE":
      return memsizeTagIcon;
    case "NETTRAFFIC":
      return nettrafficTagIcon;
    case "PRESSURE":
      return pressureTagIcon;
    case "RADIOERROR":
      return radioErrorTagIcon;
    case "RAIN":
      return rainTagIcon;
    case "RAINEVENT":
      return rainEventTagIcon;
    case "RAININTENSITY":
      return rainIntensityTagIcon;
    case "RF":
      return rfTagIcon;
    case "RFIN":
      return rfInTagIcon;
    case "RFOUT":
      return rfOutTagIcon;
    case "RH":
      return relativeHumidityTagIcon;
    case "RSSI":
      return rssiTagIcon;
    case "SM_CALIBRATED":
      return smCalibratedTagIcon;
    case "SM_GYPSUM":
      return smGypSumTagIcon;
    case "SM_PERCENTAGE":
      return smPercentageTagIcon;
    case "SM_SFU":
      return smSfuTagIcon;
    case "SM_TENSIO":
      return smTensioTagIcon;
    case "SM_WFV":
      return smWfvTagIcon;
    case "SOILTEMP":
      return soilTemperatureTagIcon;
    case "SOLARCELL":
      return solarCellTagIcon;
    case "TEMP":
      return temperatureTagIcon;
    case "TIME":
      return timeTagIcon;
    case "VOLUME":
      return volumeTagIcon;
    case "WETBULB":
      return wetbulbTagIcon;
    case "WINDDIR":
      return windDirectionTagIcon;
    case "WINDSPEED":
      return windSpeedTagIcon;
    case "WINDSPEEDPEAK":
      return windSpeedPeakTagIcon;
    case "WL_LENGTH":
      return wlLengthTagIcon;
    case "WL_PRESSURE":
      return wlPressureTagIcon;
    default:
      return tagIcon;
  }
}

export enum IconPosition {
  LEFT = "left",
  RIGHT = "right",
}

function NodeIcon(props: Props) {
  const {
    // id,
    // displayName,
    __typename, // only used as a fallback if nodeClassName is not provided (cannot be used in some cases, e.g., TemplateItem)
    nodeClassName,
    subClass,
    error,
    warn,
    // hasForecast,
    executing,
    enabled,
  } = props;
  const { iconPosition = IconPosition.LEFT } = props;
  const nodeClass = nodeClassName || typenameToNodeClassName(__typename);
  const nodeClassIcon = nodeClass
    ? nodeClassToIcon(nodeClass, subClass)
    : undefined;
  return (
    <div style={{ position: "relative", float: iconPosition }}>
      <img src={nodeClassIcon} alt="" />
      {(nodeClassName === "EXTENSION" || __typename === "ExtensionNode") && (
        <img
          src={!!enabled ? enabledExtensionIcon : disabledExtensionIcon}
          style={{ position: "absolute", left: 0, top: 11 }}
          alt=""
        />
      )}
      {!!executing && (
        <img
          src={executingExtensionIcon}
          style={{ position: "absolute", left: 0, top: 11 }}
          alt=""
        />
      )}
      {!!warn && (
        <img
          src={warnIcon}
          style={{ position: "absolute", left: 11, top: 11 }}
          alt=""
        />
      )}
      {!!error && (
        <img
          src={errorIcon}
          style={{ position: "absolute", left: 11, top: 11 }}
          alt=""
        />
      )}
    </div>
  );
}

export default NodeIcon;
